import React, { useState } from "react";
import Phone from "./Phone.png";
import Email from "./Email.png";
import Address from "./Address.png";
import { useRef } from "react";
import emailjs from "emailjs-com"

const ContactPage = () => {
    const formRef=useRef();
    const [done, setDone]=useState(false)
    const handleSubmit=(e)=>{
        e.preventDefault();

        emailjs.sendForm('service_c16dv8r', 'template_ntyg1fm', formRef.current, 'user_Ng3EjPFMfhpQqKivzotZE')
        .then((result) => {
            console.log(result.text);
            setDone(true)
        }, (error) => {
            console.log(error.text);
        });
    }
  return (
    <>
    <div className="contact-heading">
        <h1>Contact Me</h1>
    </div>
      <div className="c">
        <div className="c-bg">
          <div className="c-wrapper">
            <div className="c-left">
              <h1 className="c-title">Lets discuss your project</h1>
              <div className="c-info">
                <div className="c-info-item">
                  <img src={Phone} className="c-icon" />
                  +91 6302807019
                </div>
                <div className="c-info-item">
                  <img src={Email} className="c-icon" />
                  lchetan2002@gmail.com
                </div>
                <div className="c-info-item">
                  <img src={Address} className="c-icon" />
                  Visakhapatnam,Andhra Pradesh
                </div>
              </div>
            </div>
            <div className="c-right">
              <p className="c-desc">
                <b>What's your story?</b> Get in touch. Always available for
                freelancing if the right projects comes along me
              </p>
              <form ref={formRef} onSubmit={handleSubmit} >
                  <input type='text' placeholder="Name" name="user_name"/>
                  <input type='text' placeholder="Subject" name="user_subject"/>
                  <input type='text' placeholder="Email" name="user_email"/>
                  <textarea
                  rows="5" placeholder="Message" name="user_message"/>
                  <button>Submit</button>
                  {done && "Thank You..."}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ContactPage;
